import React from 'react';
import { useTranslation } from 'react-i18next';

export const TranslationTest: React.FC = () => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    void i18n.changeLanguage(lang);
  };

  return (
    <div style={{ padding: '20px', border: '1px solid red', margin: '10px' }}>
      <h3>Translation Test Component</h3>
      <p><strong>Current Language:</strong> {i18n.language}</p>
      <p><strong>Available Languages:</strong> {i18n.languages?.join(', ')}</p>
      <p><strong>Is Ready:</strong> {i18n.isInitialized ? 'Yes' : 'No'}</p>
             <p><strong>App Title:</strong> {t('appTitle')}</p>
       <p><strong>Save Button:</strong> {t('actions.save')}</p>
       <p><strong>Loading:</strong> {t('loading')}</p>
       <p><strong>Dashboard Title:</strong> {t('dashboard:title')}</p>
       <p><strong>Notifications:</strong> {t('notificationUI.label')}</p>
      
      <button onClick={() => handleLanguageChange('en')}>
        Switch to English
      </button>
      <button onClick={() => handleLanguageChange('ru')} style={{ marginLeft: '10px' }}>
        Switch to Russian
      </button>
      
      <div style={{ marginTop: '10px', fontSize: '12px', color: 'gray' }}>
        <p><strong>Debug Info:</strong></p>
        <p>Resources: {JSON.stringify(Object.keys(i18n.store['data'] || {}))}</p>
        <p>Namespaces: {Array.isArray(i18n.options['ns']) ? i18n.options['ns'].join(', ') : i18n.options['ns']}</p>
        <p>Current Language Resources: {JSON.stringify(Object.keys(i18n.store['data']?.[i18n.language] || {}))}</p>
        <p>Common Keys: {JSON.stringify(Object.keys(i18n.store['data']?.[i18n.language]?.['common'] || {}))}</p>
        <p>Direct Access Test: {(() => { const v = (i18n.store['data']?.[i18n.language]?.['common'] as Record<string, unknown> | undefined)?.['appTitle']; return typeof v === 'string' || typeof v === 'number' ? v : 'NOT FOUND'; })()}</p>
                 <p>t() Function Test: {i18n.t('appTitle')}</p>
        <p>Store Data Structure: {JSON.stringify(i18n.store.data, null, 2)}</p>
      </div>
    </div>
  );
};
